import { type RefObject, useEffect } from 'react';

/**
 * Sets --app-bar-height on the page to the top bar's real height, so full-height pages
 * (calc(100dvh - var(--app-bar-height))) and toasts placed under the bar match it as the
 * bar's size changes with the screen.
 */
export const useAppBarHeight = (bar: RefObject<HTMLElement | null>) => {
  useEffect(() => {
    const element = bar.current;
    if (!element) return;
    const root = document.documentElement;
    const observer = new ResizeObserver(() => {
      root.style.setProperty('--app-bar-height', `${element.offsetHeight}px`);
    });
    observer.observe(element);
    return () => {
      observer.disconnect();
      root.style.removeProperty('--app-bar-height');
    };
  }, [bar]);
};
